import * as React from 'react';
import { Provider, Text, Flex, Loader,ThemePrepared } from '@fluentui/react-northstar';
import {app, pages} from '@microsoft/teams-js';
import axios from 'axios';
import TeamsThemeHelper from '../helpers/TeamsThemeHelper';
import AuthHelper from '../helpers/Auth-Helper';
import SignIn from './SignIn';
import { Helpers } from '../helpers/Helpers';

var userIdentifier;

export default class ConfigurationComponent extends React.Component<{isMobile:boolean}, { isLoading: boolean, theme: ThemePrepared, loggedIn: boolean }> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true, theme: TeamsThemeHelper.getTheme('default'), loggedIn: false};
        app.initialize();
        app.registerOnThemeChangeHandler(this.updateTheme.bind(this));
        app.getContext()
        .then(context => {
            this.updateTheme(context.app.theme);
            userIdentifier = context.user.id + '.' + context.user.tenant.id;
            this.checkUserIfLoggedIn();
        });
    }
    componentDidMount() {
    }
    getServerInformation() {
        var filesUrl = '/Setup/GetServerInformation';
        axios.get(filesUrl)
            .then(response => {
                if (response.data != null) {
                    console.log(response.data);
                    var info = {
                        domainUrl: response.data.domainUrl,
                        redirectUrl: response.data.redirectUrl
                    };
                    if (response.data != null) {
                        pages.config.setValidityState(true);
                        pages.config.registerOnSaveHandler((saveEvent) => {
                            pages.config.setConfig({
                                websiteUrl: info.domainUrl,
                                contentUrl: info.redirectUrl + "channeltab",
                                entityId: "channelTab",
                                suggestedDisplayName: Helpers.getAppName()
                            });
                            saveEvent.notifySuccess();
                        });
                    }
                }
            })
            .catch(error => {

            });
    }
    async checkUserIfLoggedIn() {
        var authData = await AuthHelper.IsUserLoggedIn(this.props.isMobile);
        if (authData.isLoggedIn) {
            await this.getServerInformation();            
        }
        this.setState({ loggedIn: authData.isLoggedIn, isLoading: false });
    }
    private updateTheme(themeString: string | undefined): void {
        this.setState({
            theme: TeamsThemeHelper.getTheme(themeString)
        });
    }
    render() {
        return (
            <Provider theme={this.state.theme} styles={{ backgroundColor: '#F3F2F1' }}>
                {
                    (this.state.isLoading) ?
                        <Loader /> :
                        (this.state.loggedIn) ?
                            <Flex hAlign='center' vAlign='center'>
                                <Text content={`You are authenticated and you can use the Teams connect app`} />
                            </Flex>
                            : <SignIn validAccount={true} isMobile={false}/>
                }
            </Provider>
        );
    }
}

